import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,[_c(VCardText,{staticClass:"px-8 pt-8 text-center"},[_c('span',{staticClass:"body-1",domProps:{"innerHTML":_vm._s(_vm.$t(_vm.responseObject.message))}})]),_c(VCardActions,[_c(VRow,{staticClass:"ma-0",attrs:{"justify":"end"}},[_c(VBtn,{attrs:{"text":"","color":"primary"},on:{"click":_vm.close}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }